import React from 'react'
import Footer from '../components/footerComponent/footer'
import Lessons from '../components/teacherComponent/lessonsComponent'
import Header from '../components/headerComponent/header'
import {Layout} from 'antd';

export default function LessonsPage() {
    return (
        <Layout>
            <Header/>
            <Lessons/>
            <Footer/>
        </Layout>
    );
};